import { useTheme } from "./ThemeProvider";

export function ThemeToggle({ onChange, disabled = false }: { onChange?: (mode: "light" | "dark") => void; disabled?: boolean }) {
  const { mode, setMode } = useTheme();
  const next = mode === "dark" ? "light" : "dark";
  return (
    <button
      type="button"
      disabled={disabled}
      className="theme-toggle"
      onClick={() => (onChange ? onChange(next) : setMode(next))}
      aria-label={`Switch to ${next} mode`}
      title={`Switch to ${next} mode`}
    >
      <span aria-hidden>{mode === "dark" ? "☀" : "☾"}</span>
      <span className="theme-toggle-label">{mode === "dark" ? "Light" : "Dark"}</span>
    </button>
  );
}
